import { Observable } from 'rxjs';

export type SearchFn = (search: string, page: number) => Promise<void>;

export type SearchFnObservable = (
  search: string,
  page: number,
) => Observable<void>;
